import { IAttachmentObjectURL } from 'shared/models/Attachments';
import { createRequestActions, RequestType } from 'store/utils';

export const loadAttachments = createRequestActions<string, IAttachmentObjectURL[]>(
    RequestType.Get,
    'ATTACHMENT_URL',
    'attachment',
);
